<template>
    <!-- 市场物业租赁情况 -->
    <div class="component-container">
        <div class="chart-canvas" id="main"></div>
        <img class="banner" src="@/assets/images/bg-pic.png" alt="" />
        <div style="
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        display: flex;
        justify-content: center;
        align-items: center;
      ">
            <img style="
          width: calc(var(--width) * 0.1);
          height: calc(var(--width) * 0.1);
          margin-top: 11%;
        " src="@/assets/images/circle-bg.png" alt="" />
        </div>
    </div>
</template>

<script>
import * as echarts from "echarts";
import { mapState } from "vuex";
export default {
    data () {
        return {
            type: 1,
            blankData: "", //剩余
            leasedData: "", //已租
            soldData: "", //已售
            mySelf: "", //自持已租
            data: ''
        };
    },
    computed: {
        ...mapState(["dateType"]),
    },
    watch: {
        dateType (newVal, oldVal) {
            if (newVal !== oldVal) {
                this.getData();
            }
        },
    },
    async mounted () {
        this.getData();
    },
    methods: {
        //获取后台的数据
        async getData () {
            await this.$http
                .get("/screen/getPropertyLeasing?type=" + this.dateType, {})
                .then((response) => {
                    if (response.status === 200) {
                        // console.log(response);
                        // this.blankData = response.data.unsold;
                        // this.leasedData = response.data.managedRented;
                        // this.soldData = response.data.sold;
                        // this.mySelf = response.data.selfOwnedRented;
                        this.data = response.data.List
                        this.data.forEach(item => {
                            item.name = item.category
                            item.value = item.count
                        })
                    }
                });
            this.showEcharts();
        },
        showEcharts () {
            let chartDom = document.getElementById("main");
            let myChart = echarts.init(chartDom);
            const option = {
                title: {
                    text: "蔬菜类实时进场比重",
                    left: "17",
                    top: "3",
                    textStyle: {
                        color: "#00C4FF",
                    },
                },
                color: ["#F0F804", "#18DF4D", "#5A25B0", "#06F3D3", '#ee6666', '#73c0de'],
                tooltip: {
                    trigger: "item",
                    formatter: "{b} : ({d}%)",
                },

                legend: {
                    left: "center",
                    data: ["rose2"],
                },
                toolbox: {
                    show: true,
                },
                series: [
                    {
                        name: "租售情况",
                        type: "pie",
                        radius: [18, 65], //内外圆圈的的大小
                        center: ["50%", "60%"], //控制饼状图的位置
                        itemStyle: {
                            borderRadius: 5,
                            normal: {
                                label: {
                                    show: true,
                                    formatter: "{b} :  ({d}%)",
                                    textStyle: {
                                        color: "#5CCEF0", // 改变标示文字的颜色
                                        fontSize: 18,
                                    },
                                },
                                normal: {
                                    color: function (params) {
                                        var colorList = [
                                            {
                                                c1: " #fce5ca", //管理
                                                c2: "#FF9D62",
                                            },
                                            {
                                                c1: " #508DFF", //实践
                                                c2: "#26C5FE",
                                            },
                                            {
                                                c1: "#63E587", //操作
                                                c2: "#5FE2E4",
                                            },
                                        ];
                                        return new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                                            {
                                                //颜色渐变函数 前四个参数分别表示四个位置依次为左、下、右、上

                                                offset: 0,
                                                color: colorList[params.dataIndex].c1,
                                            },
                                            {
                                                offset: 1,
                                                color: colorList[params.dataIndex].c2,
                                            },
                                        ]);
                                    },
                                },
                                labelLine: {
                                    show: true,
                                    lineStyle: {
                                        length: 18, // 改变饼状图标示线的长度
                                    },
                                },
                            },
                        },
                        data: this.data,
                        // data: [
                        //     { name: "托管已租", value: this.leasedData },
                        //     { name: "自持已租", value: this.mySelf },
                        //     { name: "剩余", value: this.blankData },
                        //     { name: "已售", value: this.soldData },
                        // ],
                    },
                ],
            };
            option && myChart.setOption(option);
            myChart.resize();
        },
    },
};
</script>

<style scoped></style>
